import { render } from "./VeeValidate.vue?vue&type=template&id=4afc220b"
import script from "./VeeValidate.vue?vue&type=script&lang=ts"
export * from "./VeeValidate.vue?vue&type=script&lang=ts"
script.render = render

export default script